import {makeStyles} from "@material-ui/core";
import {white, whiteGrey} from "../../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  leftPanel: {
    backgroundColor: white,
    padding: "22px 80px 0 30px",
    [down("sm")]: {
      padding: "25px 10px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0",
      borderTopLeftRadius: "50px",
      borderTopRightRadius: "50px",
    },
  },
  leftPanelContent: {
    backgroundColor: white,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1",
    position: "relative",
    textAlign: "center",
    paddingBottom: "40px",
    borderBottomLeftRadius: "54px",
    borderBottomRightRadius: "54px",
  },
  seatImage: {
    objectFit: "cover",
    width: "100%",
    marginTop: "-140px",
    marginBottom: "44px",
    zIndex: "0",
    borderBottomRightRadius: "54px",
    borderBottomLeftRadius: "54px",
    [down("sm")]: {
      height: "172px",
      zIndex: "0",
      marginTop: "0px",
      marginBottom: "0px",
      borderRadius: "24px",
    },
  },
  rightPanel: {
    backgroundColor: whiteGrey,
    display: "flex",
    flexDirection: "column",
    padding: "40px",
    width: "540px",
    height: "100%",
    gap: "16px",
    [down("sm")]: {
      padding: "40px 10px",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
    },
  },
  title: {
    backgroundImage: "linear-gradient(90deg, #9D1D5A, #590C32)",
    color: "transparent",
    backgroundClip: "text",
    fontWeight: "bold",
    fontSize: "16px",
    textTransform: "uppercase",
    lineHeight: "14px",
    marginBottom: "12px",
  },
  subtitleText: {
    display: "flex",
    color: "#838D95",
    textAlign: "center",
    maxWidth: "720px",
    marginBottom: "20px",
  },
  planeIcon: {
    backgroundColor: whiteGrey,
    borderRadius: "50%",
    minWidth: "84px",
    minHeight: "84px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px",
    [down("sm")]: {
      minWidth: "64px",
      minHeight: "64px",
    },
  },
  tickTextWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
  },
  flightCard: {
    backgroundColor: white,
    borderRadius: "24px",
    padding: "24px 16px 8px 16px",
  },
  passengerCard: {
    backgroundColor: whiteGrey,
    maxHeight: "64px",
    borderRadius: "10px",
    marginBottom: "8px",
    padding: "10px 16px",
  },
  stepperIcon: {
    width: "10px",
    height: "58px",
  },
  totalPrice: {
    backgroundColor: white,
    display: "flex",
    flexDirection: "row",
    marginTop: "12px",
    borderRadius: "24px",
    width: "100%",
    padding: "24px",
    [down("sm")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    }
  },
  totalSum: {
    color: "#00C908",
    textAlign: "right",
    [down("sm")]: {
      textAlign: "center",
    }
  },
  totalCaption: {
    fontSize: "12px",
    color: "#71777D",
    textAlign: "right",
    [down("sm")]: {
      textAlign: "center",
    }
  },
  operatorInfo: {
    position: "sticky",
    bottom: "0",
    paddingTop: "24px",
    maxWidth: "460px",
    margin: "0 auto",
  },
  itinerary: {
    display: "flex",
    padding: "0 16px 8px 16px",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "8px",
    [down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
      gap: "16px",
    }
  },
  passengerInfo: {
    backgroundColor: whiteGrey,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 16px",
    borderRadius: "12px",
    marginBottom: "8px",
    [down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
    }
  }
}));

export default useStyles;
